import { render } from "./ComponentFilters.vue?vue&type=template&id=2c281ea2&scoped=true"
import script from "./ComponentFilters.vue?vue&type=script&lang=js"
export * from "./ComponentFilters.vue?vue&type=script&lang=js"

import "./ComponentFilters.vue?vue&type=style&index=0&id=2c281ea2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c281ea2"]])

export default __exports__